/**
 * siteAnalytics.js
 * ────────────────
 * Loads Google Analytics (gtag.js) for the public site once, from the
 * `tracking.googleAnalyticsId` the page payload carries, and reports a
 * page_view on every client-side navigation. The initial config call sends
 * no page_view: the SPA reports each route itself so the first page is not
 * counted twice.
 *
 * Consent: the Embed bundle's Consent Mode stub (Website Settings → Privacy)
 * sets `gtag('consent', 'default', …)` and is loaded as a module script, so it
 * runs before this deferred loader fires on a real page load.
 */
var loadedId = '';

/**
 * @param {Object} tracking  { googleAnalyticsId }
 * @param {Object} [opts]    { path, title }
 */
export function trackPageView(tracking, opts) {
	if (typeof window === 'undefined' || typeof document === 'undefined') return;
	var id = tracking && tracking.googleAnalyticsId ? String(tracking.googleAnalyticsId).trim() : '';
	if (!id) return;

	if (!loadedId) {
		window.dataLayer = window.dataLayer || [];
		window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
		window.gtag('js', new Date());
		window.gtag('config', id, { send_page_view: false, anonymize_ip: true });
		var script = document.createElement('script');
		script.async = true;
		script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
		document.head.appendChild(script);
		loadedId = id;
	}

	opts = opts || {};
	window.gtag('event', 'page_view', {
		send_to: id,
		page_path: opts.path || (window.location.pathname + window.location.search),
		page_title: opts.title || document.title,
		page_location: window.location.href
	});
}

/** Test hook. */
export function resetSiteAnalyticsForTests() {
	loadedId = '';
}
